import React, { Fragment, useState } from "react";
import { debounce } from "lodash";
import Icon from "@mdi/react";
import { mdiLoading, mdiMagnify } from "@mdi/js";
import Styles from "./CommuneSearch.scss";

const CommuneSearch = (props) => {
   const [coms, setComs] = useState([]);
   const [loading, setLoading] = useState();

   const debouncedSearch = debounce(async (url) => {
      if (!url) return;
      setLoading(true);
      const result = await axios.get(url);
      result?.data?.features?.length ? setComs(result.data.features) : null;
      setLoading(false);
   }, 400);

   async function handleChange(e) {
      const query = e.target.value;
      const maxResults = 7;
      const minCharacters = 3;
      if (query.length < minCharacters) return;

      let url = "https://api-adresse.data.gouv.fr/search/?q=" + query + "&limit=" + maxResults;
      debouncedSearch(url);
   }
   const handleSearch = (e) => {
      setComs([]);
      props.onSearchChange(e);
      document.querySelector("#commList").value = null;
   };

   return (
      <div className={"d-flex flex-row justify-content-center align-items-center w-100 my-3"}>
         <div
            className={"d-flex justify-content-center align-items-center items-center rounded-left"}
            style={{
               backgroundColor: "#F9F9F9",
               marginRight: "-1px",
               padding: "5px",
            }}
         >
            {loading ? (
               <Icon path={mdiLoading} spin={true} size={1.0} color={"#CCC"} />
            ) : (
               <Icon path={mdiMagnify} size={1.0} color={"#CCC"} />
            )}
         </div>
         <div
            className={"search-result-input"}
            style={{
               display: "flex",
               justifyContent: "space-between",
               alignItems: "center",
               backgroundColor: "#F9F9F9",
            }}
         >
            <input
               className="form-control"
               style={{
                  backgroundColor: "#F9F9F9",
                  height: "33px",
                  border: "none",
                  fontSize: "12px",
               }}
               type={"text"}
               id="commList"
               placeholder="Nom de la commune"
               onChange={(e) => handleChange(e)}
            />
            {coms.length ? (
               <ul className={"search-result-list"} onMouseLeave={() => setComs([])}>
                  {coms.map((item, index) => {
                     return (
                        <li
                           className={"search-result-list-item"}
                           key={index}
                           onClick={(e) => handleSearch(item.geometry.coordinates)}
                        >
                           {item.properties.label}
                        </li>
                     );
                  })}
               </ul>
            ) : null}
         </div>
      </div>
   );
};

export default CommuneSearch;
